// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {message} from './utils/resetMessage' 
import api from './http'
import { HttpService } from './http/HttpService';
import { mystorage } from './utils/myStorage'
import ElementUI from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
import ElementUIEnlocale from 'element-ui/lib/locale/lang/en'
import ElementUIZhlocale from 'element-ui/lib/locale/lang/zh-CN'
import zhlocale from  './components/lang/zh'
import enlocale from  './components/lang/en'
import VueI18n from 'vue-i18n'
import global_ from '@/utils/global.vue'//全局常量
import preview from 'vue-photo-preview'
import Print from 'vue-print-nb'
import 'vue-photo-preview/dist/skin.css'

//全部导入
import _ from 'lodash'


import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import '@/assets/element-variables.scss'

import * as echarts from 'echarts';

import 'echarts'
import ECharts from 'vue-echarts'
import "regenerator-runtime/runtime.js"; // 异步加载
import VueWechatTitle from 'vue-wechat-title'; //显示title
import infiniteScroll from 'vue-infinite-scroll'
import VueContextMenu from 'vue-contextmenu'
// import Icon from '../src/components/Icon';
// Vue.prototype.Icon=Icon;  //其中$xx为新命的名。

// import { import } from "mathjs"
// import  '@/network/mock' //引入mock.js
Vue.use(Print)
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.use(ElementUI,{
  ElementUIEnlocale
})
Vue.use(UmyUi);
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(VueWechatTitle)
Vue.use(api)
Vue.use(preview)
Vue.prototype._ = _  //全部导入的挂载方式
Vue.prototype.global = global_
Vue.prototype.$echarts = echarts;
Vue.prototype.$http=HttpService
Vue.prototype.mystorage = mystorage
Vue.prototype.$message=message  // 重写message 提示框
Vue.use(VueContextMenu)
Vue.component('VueEcharts', ECharts)
// Vue.prototype.$service=HttpService

const i18n = new VueI18n({
  
  locale: sessionStorage.getItem('locale')|| 'en',    // 语言标识
  messages: {
    en:{
      ...enlocale,
      ...ElementUIEnlocale
    },
    zh:{
      ...zhlocale,
      ...ElementUIZhlocale
    }
   
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,  // 不要忘记
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js